<template>
  <v-menu location="bottom end">
    <template v-slot:activator="{ props: menuProps }">
      <v-btn v-bind="menuProps" :color="color" :variant="variant" :size="size" :icon="!showCode"
        :title="$t('shell_language_title')" :aria-label="$t('shell_language_title')" class="mx-1">
        <v-icon :class="{ 'mr-1': showCode }">mdi-translate</v-icon>
        <span v-if="showCode">{{ locale.toUpperCase() }}</span>
      </v-btn>
    </template>

    <v-list density="compact" min-width="220">
      <v-list-subheader>{{ $t('shell_language_title') }}</v-list-subheader>
      <v-list-item v-for="option in options" :key="option.value" :active="choice === option.value"
        color="primary" @click="pick(option.value)">
        <v-list-item-title>{{ option.title }}</v-list-item-title>
        <template v-slot:append>
          <v-icon v-if="choice === option.value" size="small">mdi-check</v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
/*
 * Lets a person force the portal into English, French or Spanish, or follow the
 * browser ("Automatic"). The choice lives in this browser only (src/i18n/index.js).
 * Language names are written in their own language so anyone can find theirs.
 */
import { computed, ref } from 'vue';
import { useLocale } from 'vuetify';
import { AUTO, browserLocale, chooseLanguage, languageChoice, locale, t } from '@/i18n/index.js';

defineProps({
  color: { type: String, default: 'primary' },
  variant: { type: String, default: 'text' },
  size: { type: String, default: 'default' },
  /** Show the current language code (EN/FR/ES) beside the icon. */
  showCode: { type: Boolean, default: false },
});

const emit = defineEmits(['changed']);

const NAMES = { en: 'English', fr: 'Français', es: 'Español' };

const vuetifyLocale = useLocale();
const choice = ref(languageChoice());

const options = computed(() => [
  { value: AUTO, title: t('shell_language_auto', NAMES[browserLocale()]) },
  { value: 'en', title: NAMES.en },
  { value: 'fr', title: NAMES.fr },
  { value: 'es', title: NAMES.es },
]);

const pick = (value) => {
  choice.value = value;
  const now = chooseLanguage(value);
  vuetifyLocale.current.value = now;
  emit('changed', now);
};
</script>
